import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import {
  CREATE_TRANSACTIONNOTE_FAILURE,
  CREATE_TRANSACTIONNOTE_REQUEST,
  CREATE_TRANSACTIONNOTE_SUCCESS
} from "../types";
import { addEntities } from "../../entities";
import awsImageUpload from "../../../helpers/awsImageUpload";

export default (fundingRequestId, note, attachment) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(CREATE_TRANSACTIONNOTE_REQUEST)({}));
    let filename = [];
    if (attachment && attachment.name) {
      filename = [{ filename: attachment.name }];
    }

    const response = await api.factoring.createTransactionNote(
      fundingRequestId,
      note,
      filename
    );

    if (attachment && attachment.name) {
      await awsImageUpload(
        [attachment].map(attachment => ({
          file: attachment,
          upload_url: response.attachments[0].upload_url
        }))
      );
    }

    const data = normalize(response, schema.transactionNote);

    dispatch(addEntities(data.entities));
    dispatch(
      createAction(CREATE_TRANSACTIONNOTE_SUCCESS)({
        [fundingRequestId]: [data.result]
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(CREATE_TRANSACTIONNOTE_FAILURE)(err));
    throw err;
  }
};
